import _plugin_vue_export_helper_default from "../../_virtual/_plugin-vue_export-helper.js";
import DocSettings_vue_vue_type_script_setup_true_lang_default from "./DocSettings.vue.script.js";
/* empty css                          */
//#region src/views/Settings/DocSettings.vue
var DocSettings_default = /*#__PURE__*/ _plugin_vue_export_helper_default(DocSettings_vue_vue_type_script_setup_true_lang_default, [["__scopeId", "data-v-5134b4f8"]]);
//#endregion
export { DocSettings_default as default };

//# sourceMappingURL=DocSettings.vue.js.map